import i18n from "i18next";
import { BaseService } from "../../core/baseService";
import {
  TransferDestinationServiceInterface,
  CreateTransferDestinationParams,
  UpdateTransferDestinationParams,
  DeleteTransferDestinationParams,
  GetTransferDestinationsParams,
} from "../types/transfer.types";
import { PaginatedResponse, TransferDestination } from "../../../models";

export class TransferDestinationService
  extends BaseService
  implements TransferDestinationServiceInterface
{
  async getDestinations(params: GetTransferDestinationsParams) {
    const { page, pageSize, search } = params;
    const q = new URLSearchParams();
    q.set("page", String(page));
    q.set("pageSize", String(pageSize));
    if (search && search.trim().length > 0) q.set("q", search.trim());

    return this.handleRequest<PaginatedResponse<TransferDestination>>(
      this.client.get(`/api/admin/transfer-destinations/paged?${q.toString()}`, {
        headers: {
          "Accept-Language": i18n.language || "en-US",
        },
      }),
    );
  }

  async createDestination(params: CreateTransferDestinationParams) {
    return this.handleRequest<TransferDestination>(
      this.client.post("/api/admin/transfer-destinations", params),
    );
  }

  async updateDestination(params: UpdateTransferDestinationParams) {
    const { destinationId, data } = params;
    return this.handleRequest<TransferDestination>(
      this.client.put(
        `/api/admin/transfer-destinations/${destinationId}`,
        data,
      ),
    );
  }

  async deleteDestination(params: DeleteTransferDestinationParams) {
    const { destinationId } = params;
    return this.handleRequest<void>(
      this.client.delete(`/api/admin/transfer-destinations/${destinationId}`),
    );
  }
}
